import { User } from '../ifmsTypes';

import { now, isIsoBefore, getDateFromEpoch } from '../dateUtils';
import { parseJwt } from '../util';

const UserStorageKey = 'ifms.user';
//const UserLicProdStorageKey = 'ifms.user.licproduct';
const LastEmailStorageKey = 'ifms.lastemail';

class AuthService {
  // constructor() {
  //   this.getUser = this.getUser.bind(this);
  //   this.setUser = this.setUser.bind(this);
  //   this.rememberLastLoginEmail = this.rememberLastLoginEmail.bind(this);
  //   this.isAuthenticated = this.isAuthenticated.bind(this);
  // }
  getUser = () => {
    const userFromStorage = localStorage.getItem(UserStorageKey);
    if (!userFromStorage) {
      return null;
    }

    try {
      return JSON.parse(userFromStorage);
    } catch (err) {
      window.console.error(err);
    }

    return null;
  }
  rememberLastLoginEmail = (email:string) => {
    localStorage.setItem(LastEmailStorageKey, email);
  }
  isDifferentUserLogin = (loginEmail:string) => {
    return localStorage.getItem(LastEmailStorageKey) !== loginEmail;
  }
  setUser = (user:User) => {
    localStorage.setItem(UserStorageKey, JSON.stringify(user));
  }
  removeUser = () => {
    localStorage.removeItem(UserStorageKey);
  }
  isAuthenticated = () => {
    const currentUser = this.getUser();

    if (!currentUser) {
      return false;
    }

    return isIsoBefore(now(), currentUser.expiresAt);
  }
  getUserLoggedAtTimestamp = ()=> {
    const user = this.getUser();
    if (!user) {
      return null;
    }

    const parsedJwt = parseJwt(user.accessToken);

    return getDateFromEpoch(parsedJwt.iat);
  }
  // setUserLicProduct = (licProduct:LicProduct) => {
  //   localStorage.setItem(UserLicProdStorageKey, JSON.stringify(licProduct));
  // }
  // getUserLicProduct = () => {
  //   const userLicFromStorage = localStorage.getItem(UserLicProdStorageKey);
  //   if (!userLicFromStorage) {
  //     return null;
  //   }
  //   try {
  //     return JSON.parse(userLicFromStorage);
  //   } catch (err) {
  //     window.console.error(err);
  //   }
  //   return null;
  // }

  
  
  
}

export default AuthService;
